<template>
  <div style="width:100%">
    <Header ></Header>
    <Product></Product>
    <News></News>
    <About></About>
  </div>
</template>
<script>
import Header from "./header.vue";
import Product from "./product3.vue";
import News from "./news.vue";
import About from "./about.vue";

export default {
  data() {
    return {};
  },
  components: {
    Header,
    Product,
    News,
    About,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0 auto;
}
</style>